module.exports = __webpack_public_path__ + "img/null_goods.png?v=6e7f24e5";